var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstaGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.533,
    height: 24.533,
    viewBox: "0 0 24.533 24.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(18.802 4.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3292",
    "data-name": "Group 3292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M393,94.739a.6.6,0,1,0,.6.6A.6.6,0,0,0,393,94.739Z",
    transform: "translate(-392.401 -94.739)",
    fill: "#a6a6a6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "translate(6.986 6.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M151.084,145.8a5.28,5.28,0,1,0,5.28,5.28A5.286,5.286,0,0,0,151.084,145.8Z",
    transform: "translate(-145.804 -145.804)",
    fill: "#a6a6a6"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3297",
    "data-name": "Group 3297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M17.808,0H6.725A6.733,6.733,0,0,0,0,6.725V17.808a6.733,6.733,0,0,0,6.725,6.725H17.808a6.733,6.733,0,0,0,6.725-6.725V6.725A6.733,6.733,0,0,0,17.808,0ZM12.267,19A6.729,6.729,0,1,1,19,12.267,6.737,6.737,0,0,1,12.267,19ZM19.4,7.18a2.044,2.044,0,1,1,2.044-2.044A2.047,2.047,0,0,1,19.4,7.18Z",
    fill: "#a6a6a6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGrey);
export default __webpack_public_path__ + "static/media/insta-grey.b32f19466bb1529f80a33fc50d17f68c.svg";
export { ForwardRef as ReactComponent };